import PostsRepository from '@/repository/PostsRepository';

import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { NSNews } from '@/types/News';

interface NewsState {
  endpoint: string; // URL path
  posts: NSNews.Posts;
}

const state: NewsState = {
  endpoint: window.gmj.news.endpoint ? window.gmj.news.endpoint : '', // head()タグに定義しておいてもらう
  posts: []
};

const getters: GetterTree<NewsState, RootState> = {
  endpoint(state: NewsState) {
    return state.endpoint;
  },
  getPosts(state: NewsState) {
    return state.posts;
  }
};

const mutations: MutationTree<NewsState> = {
  /**
   * postsにPost[]を格納する
   * @param state
   * @param posts
   */
  setPosts(state: NewsState, posts: NSNews.Posts) {
    state.posts = posts;
  }
};

const actions: ActionTree<NewsState, RootState> = {
  setPosts({ commit }, posts: NSNews.Posts = []) {
    commit('setPosts', posts);
  },

  /**
   * https://qiita.com/akameco/items/cc73afcdb5ac5d0774bc
   * @param getters
   * @param dispatch
   */
  async fetchPosts({ getters, dispatch }) {
    const response = await PostsRepository.get(getters.endpoint).catch(e => {
      console.log(e);
      throw new Error(`reject fetchPosts`);
    });

    // console.log(response);

    if (
      response &&
      response.status === 200 &&
      response.data &&
      response.data.posts
    ) {
      // console.log(response.data.posts);

      dispatch('setPosts', response.data.posts);
    } else {
      dispatch('setPosts', []);
    }
  }
};

//  https://github.com/vuejs/vuex/blob/dev/types/index.d.ts#L111
export const news: Module<NewsState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
